import { render, staticRenderFns } from "./ConfigOrganization.vue?vue&type=template&id=3a08ac1f"
import script from "./ConfigOrganization.vue?vue&type=script&lang=js"
export * from "./ConfigOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports